// extracted by mini-css-extract-plugin
module.exports = {"switch":"sliderToggle-module--switch--2iawd","slider":"sliderToggle-module--slider--3cUBj"};